import { adminDefaultConfig } from 'feature/admin';
import { AdminScreen } from 'structure/admin';
import { CLICK, componentWithVariants, demoFile, story, variant } from 'system/demo';

demoFile('structure/admin');

const adminFeatures = Object.keys(adminDefaultConfig);

componentWithVariants('AdminScreen', AdminScreen, {}, [
    variant(
        'View as Owner',
        {
            state: { roles: ['Owner'] },
            structureKey: 'admin',
            features: adminFeatures,
        },
        [story('Go to Component Demo', [CLICK('Component Demo')])],
    ),
    variant('View as Developer', {
        state: { roles: ['Developer'] },
        features: adminFeatures,
        structureKey: 'admin',
    }),
    variant('View as Super-Moderator', {
        state: { roles: ['Super-Moderator'] },
        features: adminFeatures,
        structureKey: 'admin',
    }),
    variant('View as Moderator', {
        state: { roles: ['Moderator'] },
        features: adminFeatures,
        structureKey: 'admin',
    }),
    variant('View as Editorial', {
        state: { roles: ['Editorial'] },
        features: adminFeatures,
        structureKey: 'admin',
    }),
    variant('View as Analyst', {
        state: { roles: ['Analyst'] },
        features: adminFeatures,
        structureKey: 'admin',
    }),
    variant('View as logged out user', {
        state: { roles: [] },
        features: adminFeatures,
        structureKey: 'admin',
    }),
]);
